import React from 'react'

const PaginationItem = ({onClick, dataPage,  href, className, label}) => {
  return (
	<li className={className}>
		<a
			data-page={dataPage}
			href={href}
			className="page-link"
			onClick={onClick}
		>
			{label}
		</a>
	</li>
  )
}

export default PaginationItem
